
import { Component, Vue, Prop } from 'vue-property-decorator';

import * as _ from 'underscore';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import PageBase from "../PageBase.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";
import Tooltip from "@/components/survey/Tooltip.vue";

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";
import { rflmQuestionnaireDataInfoType } from '@/types/Application/ReplyFamilyLawMatter';
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { togglePages } from '@/components/utils/TogglePages';

@Component({
    components:{
        PageBase,
        Tooltip,
        LegalAssistanceFaq
    }
})
export default class RflmCounterApp extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    @applicationState.State
    public rejectedPathway!: boolean;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void
    
    selectedRepliesData = {} as rflmQuestionnaireDataInfoType;
    selectedCounters = [];
    counter = null;

    allowParentingArrangements = false;
    allowChildSupport = false;
    allowContact = false;
    allowSpousalSupport = false;
    allowCompanionAnimal = false;

    showLegalAssistance = false
    showHelpText = false

    currentStep = 0;
    currentPage = 0;

    allPages = []; 

    mounted(){      
        this.reloadPageInformation();
        this.initPageNumbers();
    }

    public reloadPageInformation() {   
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;       
        
        if (this.step.result?.rflmCounterAppSurvey?.data) {
            const counterAppData = this.step.result.rflmCounterAppSurvey.data;
            this.selectedCounters = counterAppData.counterList?counterAppData.counterList:[];
            this.counter = counterAppData.counter;           
        }

        this.enableSelection();        

        const progress = this.determineProgress();        
             
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public determineProgress(){

        let progress = 50;

        if (this.counter == null){
            progress = 50;
        } else {
            if (this.counter == 'Yes'){
                progress = this.selectedCounters.length==0? 50 : 100;
            } else {
                progress = 100;
            }
        }      

        return progress;
    }

    public enableSelection(){

        if (this.step.result?.rflmQuestionnaireSurvey?.data) {
            this.selectedRepliesData = this.step.result.rflmQuestionnaireSurvey.data;

            if (this.selectedRepliesData.selectedParentingArrangementsForm.length == 0){
                this.allowParentingArrangements = true; 
            } else {

                const index = this.selectedCounters.indexOf('parentingArrangements');
                if (index != -1){
                    this.selectedCounters.splice(index, 1);
                }

            }

            if (this.selectedRepliesData.selectedChildSupportForm.length == 0){
                this.allowChildSupport = true; 
            } else {

                const index = this.selectedCounters.indexOf('childSupport');
                if (index != -1){
                    this.selectedCounters.splice(index, 1);
                }
            }

            if (this.selectedRepliesData.selectedContactWithChildForm.length == 0){
                this.allowContact = true; 
            } else {

                const index = this.selectedCounters.indexOf('contactWithChild');
                if (index != -1){
                    this.selectedCounters.splice(index, 1);
                }
            }

            if (this.selectedRepliesData.selectedSpousalSupportForm.length == 0){
                this.allowSpousalSupport = true; 
            } else {

                const index = this.selectedCounters.indexOf('spousalSupport');
                if (index != -1){
                    this.selectedCounters.splice(index, 1);
                }
            }

            if (this.selectedRepliesData.selectedCompanionAnimalForm.length == 0){
                this.allowCompanionAnimal = true; 
            } else {

                const index = this.selectedCounters.indexOf('companionAnimal');
                if (index != -1){
                    this.selectedCounters.splice(index, 1);
                }
            }
        }
    }


    public resetPages() {                               
        togglePages(this.allPages, false, this.currentStep); 

        const rflmBackgroundPage = this.stPgNo.RFLM.RflmBackground
        if(this.$store.state.Application.steps[this.currentStep].pages[rflmBackgroundPage].progress>0)               
            Vue.filter('setSurveyProgress')(null, this.currentStep, rflmBackgroundPage, 50, false);       

        const rflmChildPage = this.stPgNo.RFLM.RflmChildrenInfo
        if(this.$store.state.Application.steps[this.currentStep].pages[rflmChildPage].progress>0) 
            Vue.filter('setSurveyProgress')(null, this.currentStep, rflmChildPage, 50, false);
    }

    public getSelectedReplies(){

        const selected = this.selectedRepliesData.selectedParentingArrangementsForm.length>0 || 
                        this.selectedRepliesData.selectedChildSupportForm.length>0 ||
                        this.selectedRepliesData.selectedContactWithChildForm.length>0 ||
                        this.selectedRepliesData.selectedGuardianshipForm.length>0 ||
                        this.selectedRepliesData.selectedSpousalSupportForm.length>0 ||
                        this.selectedRepliesData.selectedCompanionAnimalForm.length>0

        return selected;
    }

    public onChangeCounter(countering){
        this.resetPages()
        this.UpdatePathwayCompleted({pathway:"replyFlm", isCompleted:false})

        if (countering == 'No'){
            this.selectedCounters = [];
        } 

        Vue.filter('surveyChanged')('replyFlm')
    }
   
    public onChange(selectedCounters) {
        this.resetPages()
        this.UpdatePathwayCompleted({pathway:"replyFlm", isCompleted:false})        
        Vue.filter('surveyChanged')('replyFlm')               
    }

    public initPageNumbers(){
        const p = this.stPgNo.RFLM        
        this.allPages = _.range(p.RflmChildrenInfo, p.ReviewYourAnswersRFLM)
        
    }   

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();       
    }   

    public getSelectedFormsNames(){
        
        let result = ''
        if (this.counter == 'Yes'){
            for(const form of this.selectedCounters){
                if(form=='parentingArrangements')   result+='Parenting Arrangements'+'\n';
                if(form=='childSupport')            result+='Child Support'+'\n';
                if(form=='contactWithChild')        result+='Contact With a Child'+'\n';
                if(form=='guardianOfChild')         result+='Guardian Of a Child'+'\n';
                if(form=='spousalSupport')          result+='Spousal Support'+'\n';
                if(form=='companionAnimal')         result+='Companion Animal'+'\n';
            }
        } else {
            result = 'None';
        }
        
        return result;
    }
  
    beforeDestroy() {

        const progress = this.determineProgress(); 
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);        

        const questions = [
            {name:'RflmCounterApp',title:'Do you want to make a counter application?',value:this.counter},
            {name:'RflmCounterApp',title:'I need help with the following family law matter:',value:this.getSelectedFormsNames()}
        ]        
        this.UpdateStepResultData({step:this.step, data: {rflmCounterAppSurvey: {data: {counter: this.counter,  counterList: this.selectedCounters}, questions: questions, pageName:"Counter Application", currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
